import { EXPLORE_FILTER_MODE } from './use-experience-filter';
import useSetFilter, { ModeKey } from './use-set-filter';

const useSetMode = () => useSetFilter<ModeKey | undefined>(EXPLORE_FILTER_MODE);

export default useSetMode;
